import React from 'react';

export const LinkedinIcon = () => {
  return (
    <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.1"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.199219 16C0.199219 7.16344 7.36266 0 16.1992 0C25.0358 0 32.1992 7.16344 32.1992 16C32.1992 24.8366 25.0358 32 16.1992 32C7.36266 32 0.199219 24.8366 0.199219 16Z"
        fill="white"
      />
      <path
        d="M22.5242 9.12427H9.87422C9.57 9.12427 9.32422 9.37005 9.32422 9.67427V22.3243C9.32422 22.6285 9.57 22.8743 9.87422 22.8743H22.5242C22.8284 22.8743 23.0742 22.6285 23.0742 22.3243V9.67427C23.0742 9.37005 22.8284 9.12427 22.5242 9.12427ZM13.4028 20.841H11.3627V14.2788H13.4028V20.841ZM12.3836 13.3816C12.1497 13.3816 11.9211 13.3123 11.7266 13.1823C11.5322 13.0524 11.3806 12.8677 11.2911 12.6516C11.2016 12.4356 11.1782 12.1978 11.2238 11.9684C11.2694 11.739 11.3821 11.5283 11.5474 11.363C11.7128 11.1976 11.9235 11.085 12.1529 11.0393C12.3823 10.9937 12.62 11.0171 12.8361 11.1066C13.0522 11.1961 13.2369 11.3477 13.3668 11.5421C13.4967 11.7366 13.5661 11.9652 13.5661 12.1991C13.5644 12.8522 13.035 13.3816 12.3836 13.3816ZM21.0409 20.841H19.0025V17.6493C19.0025 16.8879 18.9887 15.9099 17.942 15.9099C16.8816 15.9099 16.7183 16.7383 16.7183 17.5943V20.841H14.6816V14.2788H16.6375V15.176H16.665C16.9366 14.6604 17.6017 14.1155 18.5952 14.1155C20.6611 14.1155 21.0409 15.475 21.0409 17.2419V20.841Z"
        fill="#F0F0F0"
      />
    </svg>
  );
};
